import { useManageQuoteCart } from '~/purchase/api';
import { usePlugin } from '~/common/context';
import {
  IAddCartQuoteVariable,
  IQuoteCartAction,
  IQuoteCartAddServicePayload,
  IRimType,
} from '~/purchase/types';

export const useQuoteCart = () => {
  const pluginContext = usePlugin();
  const manageCart = useManageQuoteCart({
    submit: { enabled: true },
    updatePrices: { enabled: true },
    addService: { enabled: true },
    removeService: { enabled: true },
    updateRimType: { enabled: true },
    updateItemQuantity: { enabled: true },
    removeItem: { enabled: true },
    addItem: { enabled: true },
    reset: { enabled: true },
  });
  const actions: IQuoteCartAction = {
    addService: {
      process: (data: IQuoteCartAddServicePayload, onSuccess?: () => void) => {
        manageCart.addService.mutate(data, {
          onSuccess: () => {
            onSuccess?.();
          },
        });
      },
      isLoading: manageCart.addService.isLoading,
    },
    updatePrice: {
      process: (
        data: {
          items?: Array<{ id: string; price: number }>;
          services?: Array<{ id: string; price: number }>;
        },
        onSuccess?: () => void,
      ) => {
        manageCart.updatePrices.mutate(data, {
          onSuccess: () => {
            onSuccess?.();
          },
        });
      },
      isLoading: manageCart.updatePrices.isLoading,
    },
    removeItem: {
      process: (id: string, payload?: IAddCartQuoteVariable) => {
        if (payload) {
          pluginContext.api.onDeleteFromCart?.(payload);
        }
        manageCart.removeItem.mutate(id);
      },
      isLoading: manageCart.removeItem.isLoading,
    },
    updateRimType: {
      process: (data: { rimType: IRimType }) => {
        manageCart.updateRimType.mutate(data);
      },
      isLoading: manageCart.updateRimType.isLoading,
    },
    updateItemQuantity: {
      process: (id: string, body: { quantity: number }) => {
        manageCart.updateItemQuantity.mutate({ id, body });
      },
      isLoading: manageCart.updateItemQuantity.isLoading,
    },
    removeService: {
      process: (id: string) => {
        manageCart.removeService.mutate(id);
      },
      isLoading: manageCart.removeService.isLoading,
    },
    addItem: {
      process: (data: IAddCartQuoteVariable) => {
        pluginContext.api.onAddToCart?.(data);
        manageCart.addItem.mutate(data);
      },
      isLoading: manageCart.addItem.isLoading,
    },
    reset: {
      process: () => {
        manageCart.reset.mutate();
      },
      isLoading: manageCart.reset.isLoading,
    },
  };

  return { actions };
};
